import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Accordion, AccordionItem } from 'react-sanfona';
import cx from 'classnames';
import MediaQuery from 'react-responsive';
import { CUT_POINT, DOCUMENT_TYPES } from 'config/constants';
import { FontIcon, Dialog } from 'react-toolbox';
import FlexBox from 'flexbox-react';
import styles from './documentStyles.scss';
import DocumentLink from './documentLink';
import { isImage, confirm } from '../../../utils';
import { getMinLocalDate } from '../../../utils/dateUtils';
import S from '../../../../app/screens/main/screens/phases/shared/modal.scss';
import CS from './photoCarouselStyling';
import DocumentCarousel from './carousel';
import { IconButton } from 'react-toolbox/lib/button';
import ColoredButton from 'components/ColoredButton';
import VideoModal from './Images/videoModal';

const DocumentsTable = (props) => {
  const [active, setActive] = useState(false);
  const [file, setActiveFile] = useState(0);
  const [videoFile, setActiveVideoFile] = useState({});
  const { folders, activeFolders, onFolderOpen, onFolderClose, canModifyDoc } = props;

  const folderNames = Object.keys(folders).sort((folderA, folderB) =>
    DOCUMENT_TYPES.indexOf(folderA) - DOCUMENT_TYPES.indexOf(folderB),
  );

  const titleStyle = cx([styles.row, styles.title]);
  const rowTextStyle = cx([styles.row, styles.textRow]);
  const folderStyle = cx([styles.row, styles.folder]);

  const handleThumbnailClick = (val) => { setActive(true); setActiveFile(val); };

  const handleViewVideo = (val) => {
    setActive(true);
    setActiveVideoFile(val);
  };

  const handleShowCarousel = () => setActive(true);

  const handleClose = () => { setActive(false); };

  const desktopRow = doc => (
    <div className={cx([styles.row, styles.firstRowDoc])}>
      <div className={styles.subRowDoc}>
        <div className={styles.thumbnailImage}>
          {
            isImage(doc.expiring_download_url) ?
              /* eslint jsx-a11y/no-static-element-interactions: 0 */
              <img
                onClick={() => handleThumbnailClick(doc.id)}
                role="button"
                tabIndex={doc.id}
                key={doc.id}
                className={styles.preview}
                src={doc.expiring_download_url} alt="file"
              />
            : <FontIcon
              onClick={() => handleViewVideo(doc)}
              style={{ cursor: 'pointer' }}
              className={styles.centerDoc}
              value="insert_drive_file"
            />
          }
        </div>
        <p className={styles.nameRowDoc}>
          {doc.document_name}
        </p>
      </div>
    </div>
  );

  const confirmAndNotUse = (doc) => {
    const message = doc.not_use ?
      'Are you sure you want to activate this document again?' :
      'Are you sure you want to mark this document as do not use?';
    confirm(message, { title: 'Confirm' }).then(
      () => props.onNotUseTap(doc),
      () => null,
    );
  };

  const mobileRow = doc => (
    <div className={cx([styles.subRowDoc, styles.mobileRow])}>
      {
        isImage(doc.expiring_download_url)
        ? <img onClick={() => handleThumbnailClick(doc.id)} className={styles.preview} src={doc.expiring_download_url} alt="file" />
        : <FontIcon className={styles.centerDoc} value="insert_drive_file" />
      }
      <div className={styles.mobileInfo}>
        <p className={styles.nameRowDoc}>
          <DocumentLink href={doc.expiring_download_url}>
            {doc.document_name}
          </DocumentLink>
        </p>
        <p className={styles.subInfo}>
          {`Uploaded by ${doc.user_name} on ${getMinLocalDate(doc.created_at)}`}
        </p>
      </div>
      <FontIcon
        className={cx(styles.lockIcon, { [styles.locked]: doc.not_use })}
        value={'not_interested'}
        onClick={() => confirmAndNotUse(doc)}
      />
    </div>
  );

  const titleContainer = folderName => (
    <div style={{ display: ' inline-flex', width: '100%' }}>
      <div className={folderStyle}>
        <FontIcon value="folder_open" />
        <span className={styles.folderTitleText}>{folderName}</span>
      </div>
      <div style={{ width: '50%', margin: '9px' }}>
        {folderName === 'Photos' ?
          <ColoredButton onClick={handleShowCarousel}>Open Carousel</ColoredButton> :
          null}
      </div>
    </div>
  );

  return (
    <div>
      <FlexBox>
        <p className={titleStyle}>Document Name</p>
        <p className={titleStyle}>Uploaded By</p>
        <p className={titleStyle}>Uploaded On</p>
      </FlexBox>
      <Accordion allowMultiple activeItems={activeFolders}>
        {folderNames.map((folderName) => {
          const folderDocs = folders[folderName];
          return (
            <AccordionItem
              titleClassName={styles.titleClassName}
              title={titleContainer(folderName)}
              slug={folderName}
              key={folderName}
              onExpand={() => onFolderOpen(folderName)}
              onClose={() => onFolderClose(folderName)}
            >
              {folderDocs.map(doc => (
                <FlexBox key={doc.id} className={doc.not_use ? styles.rowLocked : null}>
                  <MediaQuery minWidth={CUT_POINT}>
                    {desktopRow(doc)}
                  </MediaQuery>
                  <MediaQuery maxWidth={CUT_POINT - 1}>
                    {mobileRow(doc)}
                  </MediaQuery>
                  <div className={rowTextStyle}>
                    {doc.user_name}
                  </div>
                  <FlexBox justifyContent="space-between" className={rowTextStyle}>
                    <div>
                      {getMinLocalDate(doc.created_at)}
                    </div>
                    <div>
                      <DocumentLink href={doc.expiring_download_url}>
                        <FontIcon className={styles.downloadIcon} value="launch" />
                      </DocumentLink>
                      {canModifyDoc && <FontIcon
                        className={cx(styles.lockIcon, { [styles.locked]: doc.not_use })}
                        value={'not_interested'}
                        onClick={() => confirmAndNotUse(doc)}
                      />}
                    </div>
                  </FlexBox>
                </FlexBox>
              ))}
            </AccordionItem>
          );
        })}
      </Accordion>
      <Dialog
        active={active}
        className={CS.modal} type="fullscreen"
        onEscKeyDown={handleClose} onOverlayClick={handleClose}
      >
        <IconButton
          icon="close"
          className={S.close}
          onClick={handleClose}
        />
        <div
          className={CS.carouselContainer}
        >
          {videoFile.document_type === 'Videos'
          ? <VideoModal src={videoFile} />
          : <DocumentCarousel src={folders} idx={file} />}
        </div>
      </Dialog>
    </div>
  );
};

DocumentsTable.propTypes = {
  folders: PropTypes.object.isRequired,
  onNotUseTap: PropTypes.func.isRequired,
  onFolderOpen: PropTypes.func.isRequired,
  onFolderClose: PropTypes.func.isRequired,
  activeFolders: PropTypes.array.isRequired,
  canModifyDoc: PropTypes.bool.isRequired,
};

export default DocumentsTable;



// WEBPACK FOOTER //
// ./client/app/shared/components/DocumentsTable/index.jsx